import { Modal } from './Modal';

type Props = {
  open: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
};

export function ConfirmDialog({ open, title, message, confirmText = 'Подтвердить', cancelText = 'Отмена', onConfirm, onClose }: Props) {
  if (!open) return null;
  return (
    <Modal title={title} onClose={onClose}>
      <p style={{whiteSpace:'pre-wrap'}}>{message}</p>
      <div style={{marginTop:12, display:'flex', gap:8}}>
        <button onClick={onConfirm} style={{background:'#dc2626'}}> {confirmText} </button>
        <button className="secondary" onClick={onClose}>{cancelText}</button>
      </div>
    </Modal>
  );
}


